import type { AllConsentNames, ConsentSnapshot } from 'c15t';

let latest: ConsentSnapshot | null = null;

export function setConsentSnapshot(snapshot: ConsentSnapshot): void {
  latest = snapshot;
}

export function getConsentSnapshot(): ConsentSnapshot | null {
  return latest;
}

export function hasConsent(category: AllConsentNames): boolean {
  return latest?.effectivePermissions[category] ?? false;
}
